module.exports = __webpack_public_path__ + "static/media/contact.1801fc40.svg";